import { PosIconProps, SvgWrapper } from 'src/svgs/SvgWrapper';

export function ArrowDownIcon7(props: PosIconProps) {
  return (
    <SvgWrapper fill="currentColor" {...props} viewBox="0 0 16 16">
      <path d="M2.5 10L8 15.5l5.5-5.5H9V1H7v9z" />
    </SvgWrapper>
  );
}
